import { Component, Input } from '@angular/core';

import { AFormat } from '@df/interfaces';

@Component({
    selector: 'app-exercise-preview-magicbox',
    templateUrl: './exercise-preview-magicbox.component.html',
    styleUrls: ['./exercise-preview-magicbox.component.scss']
})
export class ExercisePreviewMagicboxComponent {
    @Input() mb_body: Array<any>;
    @Input() mainCardView = false;
    @Input() exercise: any;
    @Input() card_format: string;
    @Input() index: number;

    constructor() {}

    getWidth(card_format) {
        if (card_format === AFormat.A6_FORMAT) {
            return '45%';
        }
        return '60%';
    }

    getHeight(card_format) {
        if (
            card_format === AFormat.A7_FORMAT ||
            card_format === AFormat.A3_FORMAT ||
            card_format === AFormat.A6_FORMAT
        ) {
            return '80px';
        }
        return '70px';
    }

    getMargin(card_format) {
        if (card_format === AFormat.A7_FORMAT || card_format === AFormat.A3_FORMAT) {
            return '10%';
        }
        return '5%';
    }
}
